export default __webpack_public_path__ + "static/media/leftWhiteArrow.e7b3418a.svg";